export default __webpack_public_path__ + "static/media/22.bc36e024.jpg";